<template>
    <div>
      <div class="row">
        <div class="col-6">
          <i class="ml-2 bi bi-question-circle-fill" data-toogle="tooltip" title="This plot has an on hover functionality"
             v-bind:style="{ fontSize : '15px'}" v-b-tooltip.hover></i>
        </div>
        <div class="col-6" v-bind:style="{ width:'100%', textAlign: 'right', paddingRight:'20px' }">
          <i class=" mr-1 bi bi-sliders" data-toogle="tooltip" title="Settings" v-b-modal="componentId+'-modal'"
             v-bind:style="{ fontSize : '15px'}"></i>
          <i class=" mr-1 bi bi-card-text" data-toogle="tooltip" title="legend" v-bind:style="{fontSize : '15px'}" v-b-modal="componentId+'-legend'"></i>
          <i class="mr-1 bi bi-save-fill" data-toogle="tooltip" title="Export" v-bind:style="{ fontSize : '12px'}"
             v-b-modal="componentId+'-modal-save'"></i>
          <i class=" mr-1 bi bi-files" data-toogle="tooltip" title="Duplicate" v-on:click="cloneCurrentWidget"
             v-bind:style="{ fontSize : '12px'}"></i>
        </div>
      </div>
        <div class="widget-legend legend">
            <span :id="componentId+'plot_title'">{{ parameter.text }} distribution grouped by {{ groupBy }} </span>
        </div>
        <PcRepartitionWidget :plotData="plotData" :axisLabel="axisLabel" :componentId="componentId"
                             :advanced="advanced"></PcRepartitionWidget>
        <div>
            <b-modal :id="componentId+'-modal'" title="Physico-chemical distribution">

        <div class="form-group mt-2" style="font-size: 1.6vmin;">
          <b-form-group label="Parameter">
            <select v-model="parameter" class="form-control">
              <option v-for="option in parameters" v-bind:key="option.value" :value="option">
                {{ option.text }}
              </option>
            </select>
          </b-form-group>
          <div class="form-group mt-2">
            <b-form-group label="Grouped by">
              <select v-model="groupBy" class="form-control">
                <option v-for="option in groupByOptions" v-bind:key="option.value"
                        :value="option.value">
                  {{ option.text }}
                </option>
              </select>
            </b-form-group>
          </div>
          <div class="form-group mt-2">
            <b-form-group label="Depth">
              <select v-model="depth" class="form-control">
                <option v-for="option in depthCodes" v-bind:key="option.depth" :value="option.depth">
                  {{ option.depth }}
                </option>
              </select>
            </b-form-group>
          </div>
          <div>
            <b-form-checkbox
                :id="componentId+'advanced'"
                v-model="advanced"
                name="advanced_splitting"
                value="checked"
                unchecked-value="not_checked"
            >
              Advanced Splitting
            </b-form-checkbox>
          </div>
          <div class="form-group mt-2" style="font-size: 1.6vmin;" v-if="advanced === 'checked'">
            <template>
              <b-form-group label="Splitting : " v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                    :id="componentId+'radio-group-advanced'"
                    v-model="splitBy"
                    :options="advancedSplittingOptions"
                    :aria-describedby="ariaDescribedby"
                    name="split-options"
                ></b-form-radio-group>
              </b-form-group>
            </template>
          </div>
        </div>
      </b-modal>
    </div>
    <b-modal :id="componentId+'-legend'" title="Legend">
      HTML allowed
      <textarea class="col-12" v-model="legend" placeholder="add multiple lines"></textarea>

      <b-button v-b-toggle="'collapse'+ componentId" variant="primary">Show/Hide</b-button>
    </b-modal>
    <ExportDialog :componentId="componentId" :formattedData="formattedData" :plotData="plotData"
                  :exportFileName="exportFileName"
                  :dataset="dataset" :legend="legend"></ExportDialog>
    <div>
      <b-collapse v-model="visible" :id="'collapse'+componentId" class="">
        <b-card>
          <div v-html="legend">
          </div>

        </b-card>
      </b-collapse>
    </div>

  </div>
</template>


<script>
/* eslint-disable vue/no-dupe-keys */
import axios from "axios";
import PcRepartitionWidget from "./PcRepartitionWidget";
import {mapActions} from "vuex";
import {ApiCall} from "../mixins/ApiMixin";
import ExportDialog from "./ExportDialog.vue";


export default {
  name: "PcRepartition",
  props: ['panelId', 'componentId', 'triggerValue', 'settings'],
  mixins: [ApiCall],
  data() {
    return {
      dataset: null,
      depthCodes: {},
      depth: null,
      advancedSplittingOptions: [
        {text: 'By Depth', value: 'depth'},
        {text: 'By Year', value: 'year'},
        {text: 'By Cluster', value: 'cluster'},
        {text: 'By Station', value: 'station'}
      ],
      groupByOptions: [
        {text: 'Station', value: 'station_code'},
        {text: 'Season', value: 'season'},
        {text: 'Year', value: 'year'},
        {text: 'Month', value: 'month'},
      ],
      groupBy: null,
      advanced: "not_checked",
      splitBy: null,
      legend: null,
      dateStart: null,
      dateEnd: null,
      formattedData : null,
      parameters: [],
      parameter: {},

      axisLabel: "",
      plotData: null,
      visible: false,
      settings_hash: "",
      exportFileName: "mygod_physico_chemical_plot",
      apiCallsInProgress: 0
    }
  },
  components: {
    PcRepartitionWidget,
    ExportDialog
  },

  created() {
    this.updateContents()
  },

  watch: {

    triggerValue() {
      this.updateContents()
    },
    groupBy() {
      this.drawPlot()
    },
    parameter() {
      this.drawPlot()
    },
    fraction() {
      this.drawPlot()
    },
    depth() {
      this.drawPlot()
    },
    advanced() {
      if (this.advanced === 'not_checked') {
        this.splitBy = null
      }
    },
    splitBy() {
      this.drawPlot()
    },
    legend() {
      this.updateDashboardWidgetLegend({
        'componentId': this.componentId,
        'legend': this.legend
      })
    },
    plotData() {
      this.reformatData()
    }

  },

  methods: {

    ...mapActions([
      'updateDashboardWidgetSettings',
      'cloneWidget',
      'updateDashboardWidgetLegend'
    ]),

    updateContents() {
      let panel = this.$store.state.panels[this.panelId]

      let newPanelSettingsHash = panel.dataset + panel.dateStart + panel.dateEnd
      if (newPanelSettingsHash === this.settingsPanelHash) {
        return
      }
      this.settingsPanelHash = newPanelSettingsHash
      this.plotData = null

      this.dataset = panel.dataset
      this.dateStart = panel.dateStart
      this.dateEnd = panel.dateEnd

      this.initializeGroupBy()
      this.initializeLegend()
      this.initializeSplitBy()
      this.initializeParameters()
      this.initializeDepthCode()
    },


    /*
      Method to be used by all other methods needing to (re)generate the plot.
      For now, it only calls getAxisLabel() which cascades to getPlotData().
      But this may change in the future.
      Other methods are not supposed to call getAxisLabel() directly.
     */
    drawPlot() {
      this.getAxisLabel()
    },

    getPlotData() {
      if (this.apiCallsInProgress > 0) {
        setTimeout(this.getPlotData, 2000)
        return
      }
      if (this.dataset && this.parameter.value && this.dateStart && this.dateEnd && this.groupBy + this.depth) {
        let newSettingsHash = this.dataset + this.parameter.value + this.dateStart + this.dateEnd + this.groupBy + this.depth + this.splitBy

        if (newSettingsHash === this.settings_hash) {
          return
        }

        this.settings_hash = newSettingsHash
        this.plotData = null

        this.updateDashboardWidgetSettings({
          'componentId': this.componentId,
          'settings': {
            'dataset': this.dataset,
            'groupBy': this.groupBy,
            'parameter': this.parameter,
            'dateStart': this.dateStart,
            'dateEnd': this.dateEnd,
            'depth': this.depth,
            'splitBy': this.splitBy,
            'legend': this.legend,
            'advanced': this.advanced
          }
        })

        let me = this
        axios
            .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['physico_chemical_repartition',
            this.dataset, this.dateStart, this.dateEnd, this.parameter['value'],this.groupBy,this.depth,this.splitBy]))
            .then(function (response) {
              me.plotData = response.data
            })
      } else {
        console.debug("getPlotData() " + this.componentId + ": undefined parameters, no actual data  retrieval attempted.")
      }
    },


  }
}

</script>

<style scoped>
.radio-button-font {
  font-size: large;
}

</style>